import React from 'react';
import { Fade, Slide, SlideProps } from '@material-ui/core';

export const FadeTransition = React.forwardRef((props: SlideProps, ref) => <Fade ref={ref} {...props} />);

export const SlideTransition = React.forwardRef(
    ({ direction = 'up', ...props }: SlideProps, ref) => <Slide direction={direction} ref={ref} {...props} />
);